import CloseIcon from '../assets/icons/close.svg?react'
import SendIcon from '../assets/icons/send.svg?react'
import AddIcon from '../assets/icons/add.svg?react'

/**
 * Get your icon from Dukascopy-Design-System in Figma
 * then
 * Remove width="xx" height="xx" from svg tag and try change viewBox to crop the shape if you need
 * then
 * Pass them into Icon.tsx or IconButton.tsx component in icon={<YourIcon/>} prop
 * */
export const Close = CloseIcon
export const Send = SendIcon
export const Add = AddIcon
